export default "<div class=gw-facilities-map> <ng-map ng-if=$ctrl.facilities max-zoom=10> <marker ng-repeat=\"facility in $ctrl.facilities\" position=\"{{ facility.latitude }},{{ facility.longitude }}\" zoom-to-include-markers=true></marker> </ng-map> </div> ";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/common/facilities-map/facilities-map.html
// module id = kC04
// module chunks = 1